import type { GridAssertions } from "@/features/fields-grid";
import type { EventAssertion } from "@/entities/form-metadata";
import type { GridSpan } from "@/shared/components/Grid";

interface GridLayoutConfig {
    fieldsetLabel: GridSpan;
    assertions: GridAssertions<EventAssertion>;
}

export const EVENT_GRID_LAYOUT: GridLayoutConfig = {
    fieldsetLabel: 2,
    assertions: {
        desktop: { Year: 3, Day: 2, Month: 2, Place: 5 },
        tablet: { Year: 3, Day: 2, Month: 2, Place: 5 },
        mobile: { Year: 4, Day: 4, Month: 4, Place: 12 },
    },
};

export const YEAR_RANGE_GRID_LAYOUT: Omit<GridLayoutConfig, "fieldsetLabel"> = {
    assertions: {
        desktop: { ...EVENT_GRID_LAYOUT.assertions.desktop, Place: 11, Year: 12 },
        tablet: { ...EVENT_GRID_LAYOUT.assertions.tablet, Place: 11, Year: 12 },
        mobile: { ...EVENT_GRID_LAYOUT.assertions.mobile, Place: 11, Year: 12 },
    },
};
